import React from 'react';
import { BADGE_STATUS, StatusBadge } from '../../../_lib/components/Badge';
import { DateFormat } from '../../../_lib/components/DateFormat';
import { Hyperlink, HyperlinkTarget } from '../../../components/atoms/Hyperlink';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { ColumnIdentifier } from '../../../components/organisms/Table';
import { ContentAttachmentList } from '../../../components/molecules/ContentAttachmentList/ContentAttachmentList';
import { TeaserListItem } from '../../../_lib/components/TeaserList';
import { getDisplayedTextByConfig } from '../PageListDetails.utils';
import { DisplayOptions, PageListTeaserPage } from '../PageListDetails.types';

type PageListTeaserItemProps = {
  page: PageListTeaserPage;
  showColumn: (any: string) => boolean;
  displayOptions: DisplayOptions;
};

const getArchivedBadge = (page: PageListTeaserPage) => {
  return page.archived ? <StatusBadge status={BADGE_STATUS.ARCHIVED} archiveDate={page.archiveDate} /> : null;
};

export function PageListTeaserItem({ page, showColumn, displayOptions }: PageListTeaserItemProps) {
  const description = getDisplayedTextByConfig(page, displayOptions.displayedInformationType);
  return (
    <TeaserListItem
      pageLinkUrl={page.pageLink.url}
      pageLinkName={page.pageLink.name}
      categories={page.categories}
      integrated={page.integrated}
      packState={page.packState}
      teaserImageUrl={page.teaserImage?.url}
      description={description}
      headerExtra={getArchivedBadge(page)}
      date={<DateFormat className="teaser-list__date font-regular-14-19" date={page.contentDate} />}
      footer={
        <>
          {page.externalLink && (
            <p className="teaser-list__link-container">
              <Hyperlink
                className="teaser-list__external-link font-regular-14-19"
                to={page.externalLink.url}
                external
                target={HyperlinkTarget.BLANK}
              >
                <SVG svgClass="teaser-list__external-link-icon" svgSpriteId={Icons.EXTERNAL_LINK_ARROW} />
                {page.externalLink.name}
              </Hyperlink>
            </p>
          )}
          {typeof page.attachments !== 'undefined' &&
            page.attachments.length > 0 &&
            showColumn(ColumnIdentifier.attachment) && (
              <div className="teaser-list__item-attachments-container">
                <ContentAttachmentList
                  attachments={page.attachments}
                  hasMoreAttachments={page.hasMoreAttachments}
                  moreAttachmentsUrl={page.pageLink}
                />
              </div>
            )}
        </>
      }
    />
  );
}
